<template>
  <!-- 数字报--检索 -->
  <div class="search">
    <div class="container">
      <div class="header">
        <img src="../../../public/image/header.png" alt="" />
        <!-- <div class="header_content">
                    <button>报纸检索</button>
                </div> -->
      </div>
      <div class="search_container">
        <div class="search_form">
          <div class="search_main">
            <div class="s_newspapers">
              <label for="newspapers">报纸</label>
              <ul>
                <li
                  @click="checkItem(newspaper)"
                  v-for="newspaper in newspaperList"
                  :key="newspaper.digitalNewspaperMediaId"
                >
                  <checkbox :checked="isChecked(newspaper).flag"></checkbox>
                  <span v-text="newspaper.digitalNewspaperName"></span>
                </li>
              </ul>
            </div>
            <div class="s_title">
              <label for="s_title">标题</label>
              <div
                class="input_container"
                :class="{ hasError: errors.first('标题') }"
              >
                <input
                  v-validate="'maxLength:200'"
                  type="text"
                  id="s_title"
                  name="标题"
                  placeholder="同时搜索标题、引题、副题，多个关键词用空格确认"
                  v-model="documentTitle"
                  @keyup.enter="search"
                />
                <span v-if="errors.first('标题')" class="err_msg">
                  标题长度不能超过200个字符
                </span>
              </div>
              <!-- WZRB-1192【互联网读报】数字报检索，标题和正文关键词增加或与且逻辑。 -->
              <div class="s_title_btn">
                <input
                  type="checkbox"
                  @click="changeRelation('title', 0)"
                  :checked="titleRelation == 0"
                /><label>或</label>
                <input
                  type="checkbox"
                  @click="changeRelation('title', 1)"
                  :checked="titleRelation == 1"
                /><label>且</label>
              </div>
            </div>
            <div class="s_text">
              <label for="s_text">正文</label>
              <div
                class="input_container"
                :class="{ hasError: errors.first('正文') }"
              >
                <input
                  type="text"
                  id="s_text"
                  name="正文"
                  v-validate="'maxLength:200'"
                  placeholder="多个关键词用空格确认"
                  v-model="documentContent"
                  @keyup.enter="search"
                />
                <span v-if="errors.first('正文')" class="err_msg">
                  正文长度不能超过200个字符
                </span>
              </div>
              <div class="s_text_btn">
                <input
                  type="checkbox"
                  @click="changeRelation('content', 0)"
                  :checked="contentRelation == 0"
                /><label>或</label>
                <input
                  type="checkbox"
                  @click="changeRelation('content', 1)"
                  :checked="contentRelation == 1"
                /><label>且</label>
              </div>
            </div>
            <div class="s_time">
              <label for="s_time">时间</label>
              <div class="input_container">
                <dateTimeRangePicker
                  @change="changeDate"
                  :currSelectDate.sync="currSelectDate"
                ></dateTimeRangePicker>
              </div>
            </div>
            <div class="s_author">
              <label for="s_author">作者</label>
              <div
                class="input_container"
                :class="{ hasError: errors.first('作者') }"
              >
                <input
                  type="text"
                  id="s_author"
                  name="作者"
                  v-validate="'maxLength:50'"
                  v-model="documentAuthor"
                  @keyup.enter="search"
                />
                <span v-if="errors.first('作者')" class="err_msg">
                  作者长度不能超过50个字符
                </span>
              </div>
            </div>
            <div class="s_edition">
              <label for="s_edition">版次</label>
              <div
                class="input_container"
                :class="{ hasError: errors.first('版次') }"
              >
                <input
                  type="text"
                  id="s_edition"
                  name="版次"
                  v-model="edition"
                  v-validate="'maxLength:50'"
                  @keyup.enter="search"
                />
                <span v-if="errors.first('版次')" class="err_msg">
                  版次长度不能超过50个字符
                </span>
              </div>
            </div>
            <div class="s_edition_name">
              <label for="s_edition_name">版名</label>
              <div
                class="input_container"
                :class="{ hasError: errors.first('版名') }"
              >
                <input
                  type="text"
                  id="s_edition_name"
                  name="版名"
                  v-validate="'maxLength:100'"
                  v-model="editionName"
                  @keyup.enter="search"
                />
                <span v-if="errors.first('版名')" class="err_msg">
                  版面名称不能超过100个字符
                </span>
              </div>
            </div>
          </div>
          <div class="search_button">
            <button class="btn_search" @click="search">检索</button>
            <button class="btn_reset" @click="reset">重置</button>
          </div>
        </div>
        <div class="search_list">
          <ul>
            <li
              @click="gotoDetail(item)"
              v-for="item in resultList"
              :key="item.layoutDetailId"
            >
              <div class="first_row">
                <div class="li_title" v-html="item.documentTitle"></div>
                <div class="li_time">{{ item.publishTime }}</div>
              </div>
              <div class="sec_row">
                <div v-if="item.introduction" class="introduction">
                  <span class="mb1">[ </span>
                  <span class="introduction_title">引题：</span>
                  <span
                    class="introduction_content"
                    v-html="item.introduction"
                  ></span>
                  <span class="mb1"> ]</span>
                </div>
                <div v-if="item.subtitle" class="subtitle">
                  <span class="mb1">[ </span>
                  <span class="subtitle_title">副题：</span>
                  <span class="subtitle_content" v-html="item.subtitle"></span>
                  <span class="mb1"> ]</span>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="page.totalItems > page.pageSize" class="pagination_box">
            <pagination
              :totalPages.sync="page.totalPages"
              :totalItems.sync="page.totalItems"
              :pageSize.sync="page.pageSize"
              :currentPage.sync="page.currentPage"
              :showPagesNum="5"
              :homePage="1"
              :hasPageNum="true"
              :hasSelectPageSize="true"
              :hasJumpPage="true"
              @change="changePage()"
            />
          </div>
        </div>
      </div>
      <div class="footer pc">
        温州日报报业集团 版权所有 本系统支持1366*768及以上分辨率
      </div>
      <div class="footer mobile">温州日报报业集团 版权所有</div>
    </div>
  </div>
</template>
<script>
import pagination from "../../components/pagination";
import checkbox from "../../components/checkbox";
export default {
  name: "search",
  components: {
    pagination,
    checkbox,
  },
  data() {
    return {
      newspaperList: [],
      digitalNewspaperMediaIds: "", //被选中报纸的id集合
      documentTitle: "", //稿件标题
      documentContent: "", //稿件正文
      documentAuthor: "", //稿件作者
      edition: "", //版次
      editionName: "", //版面名称
      startTime: "",
      endTime: "",
      currSelectDate: {
        //选中日期,日期控件用
        beginDay: "",
        endDay: "",
      },
      titleRelation: 0, //标题关系（0或1且）默认或
      contentRelation: 0, //正文关系（0或1且）默认或
      page: {
        currentPage: 1,
        totalPages: 0,
        pageSize: 20,
        totalItems: 0,
      },
      resultList: [],
    };
  },
  mounted() {
    this.getNewspaperList();
  },
  computed: {
    /**
     * [isChecked description] 节点是否被选中
     * @return {Boolean} [description]
     */
    isChecked() {
      let digitalNewspaperMediaIdsArray =
        this.digitalNewspaperMediaIds == ""
          ? []
          : this.digitalNewspaperMediaIds.split(",");
      return (item) => {
        let index = digitalNewspaperMediaIdsArray.findIndex((id) => {
          return item.digitalNewspaperMediaId == id;
        });
        return index >= 0
          ? {
              flag: true,
              index: index,
            }
          : {
              flag: false,
            };
      };
    },
  },
  methods: {
    /**
     * [gotoDetail description]  进入稿件详情页
     * @param  {[type]} docInfo [description] 稿件信息
     * @return {[type]}         [description]
     */
    gotoDetail(docInfo) {
      let router = this.$router.resolve({
        path: "/newspaper",
        query: {
          mediaKey: docInfo.digitalNewspaperMark, //当前稿件所属报种的唯一标识
          publishTime: docInfo.publishTime, //当前稿件的发布时间
          curEdition: docInfo.edition, //当前稿件的版次
          docId: docInfo.layoutDetailId, //当前稿件的id
          isSearch: true,
        },
      });
      window.open(router.href, "_blank");
    },
    /**
     * [reset description] 重置条件
     * @return {[type]} [description]
     */
    reset() {
      this.digitalNewspaperMediaIds = "";
      this.documentTitle = ""; //稿件标题
      this.documentContent = ""; //稿件正文
      this.documentAuthor = ""; //稿件作者
      this.edition = ""; //版次
      this.editionName = ""; //版面名称
      this.startTime = "";
      this.endTime = "";
      this.currSelectDate = {
        //选中日期,日期控件用
        beginDay: "",
        endDay: "",
      };
      this.page = {
        currentPage: 1,
        totalPages: 0,
        pageSize: 20,
        totalItems: 0,
      };
      this.resultList = [];
      this.titleRelation = 0;
      this.contentRelation = 0;
    },
    /**
     * [pickDate description] 选择日期
     * @return {[type]} [description]
     */
    changeDate() {
      this.currSelectDate;
      this.startTime = this.currSelectDate.beginDay;
      this.endTime = this.currSelectDate.endDay;
    },
    /**
     * [checkItem description] 选中报纸
     * @param  {[type]} newspaper [description] 被选中的报纸
     * @return {[type]}           [description]
     */
    checkItem(newspaper) {
      let digitalNewspaperMediaIdsArray =
        this.digitalNewspaperMediaIds == ""
          ? []
          : this.digitalNewspaperMediaIds.split(",");
      let result = this.isChecked(newspaper);
      if (result.flag) {
        digitalNewspaperMediaIdsArray.splice(result.index, 1);
      } else {
        digitalNewspaperMediaIdsArray.push(newspaper.digitalNewspaperMediaId);
      }
      this.digitalNewspaperMediaIds = digitalNewspaperMediaIdsArray.join(",");
    },
    /**
     * [getNewspaperList description] 获取报纸列表
     * @return {[type]} [description]
     */
    getNewspaperList() {
      this.post("/digitalNewspaper/web/digitalNewspaperMedia/list").then(
        (resp) => {
          this.newspaperList = resp.msg.rows;
        }
      );
    },
    /**
     * @description: 切换标题和正文关系
     * @param {*} type
     * @param {*} val
     * @return {*}
     */
    changeRelation(type, val) {
      if (type == "title") {
        this.titleRelation = val;
      } else {
        this.contentRelation = val;
      }
    },
    /**
     * [search description] 开始检索
     * @return {[type]} [description]
     */
    search() {
      let self = this;
      if (!self.digitalNewspaperMediaIds) {
        self.$msg({
          type: "info",
          content: "请至少选中一种报纸",
          time: 1000,
        });
        return;
      }
      this.$validator.validateAll().then((resp) => {
        if (!resp) {
          return;
        }
        let params = {
          digitalNewspaperMediaIds: this.digitalNewspaperMediaIds,
          documentTitle: this.documentTitle,
          documentContent: this.documentContent,
          startTime: this.startTime,
          endTime: this.endTime,
          documentAuthor: this.documentAuthor,
          edition: this.edition,
          editionName: this.editionName,
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
          titleRelation: this.titleRelation,
          contentRelation: this.contentRelation,
        };
        this.post(
          "/digitalNewspaper/web/digitalNewspaperMedia/query",
          params
        ).then((resp) => {
          if (resp.msg.rows instanceof Array && resp.msg.rows.length > 0) {
            this.resultList = resp.msg.rows;
            this.resultList.forEach((item) => {
              let reg = new RegExp(self.documentTitle, "ig");
              item.documentTitle = item.documentTitle.replace(reg, ($a, $b) => {
                return `<font color="red">${$a}</font>`;
              });
              item.introduction = item.introduction
                ? item.introduction.replace(reg, ($a, $b) => {
                    return `<font color="red">${$a}</font>`;
                  })
                : "";
              item.subtitle = item.subtitle
                ? item.subtitle.replace(reg, ($a, $b) => {
                    return `<font color="red">${$a}</font>`;
                  })
                : "";
            });
            this.page = {
              currentPage: resp.msg.pageNum == 0 ? 1 : resp.msg.pageNum,
              totalPages: resp.msg.totalPages,
              pageSize: resp.msg.pageSize,
              totalItems: resp.msg.totalItems,
            };
          }
        });
      });
    },
    /**
     * [changePage description]切换分页
     * @return {[type]} [description]
     */
    changePage() {
      this.search();
    },
  },
};
</script>
<style scoped lang="less">
.search {
  height: 100%;
  position: relative;
  overflow-y: auto;
  box-sizing: border-box;
  background-color: transparent;

  .container {
    width: 100%;
    height: 100%;
  }

  .header {
    width: 100%;
    position: relative;

    img {
      width: 100%;
      object-fit: cover;
    }

    .header_content {
      width: 1200px;
      height: 100%;
      box-sizing: border-box;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      text-align: right;
      line-height: 100%;
      vertical-align: middle;
      top: 0;

      button {
        font-size: 20px;
        color: #ffffff;
        text-align: center;
        top: 50%;
        position: relative;
        transform: translateY(-50%);
        background-color: transparent;
      }
    }
  }

  .search_container {
    width: 1200px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    min-height: calc(100% - 150px - 90px - 68px);
    background-color: #fff;

    .search_form {
      vertical-align: middle;

      .search_main {
        .s_newspapers {
          li {
            cursor: pointer;
          }

          .hide_input {
            display: none;
          }

          .err_msg {
            color: red;
            font-size: 12px;
          }
        }
        .s_title {
          .s_title_btn {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            margin-bottom: 0;
            margin-left: 6px;
            label {
              position: relative;
              bottom: 2px;
            }
          }
        }
        .s_text {
          .s_text_btn {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            margin-bottom: 0;
            margin-left: 6px;
            label {
              position: relative;
              bottom: 2px;
            }
          }
        }

        div {
          vertical-align: middle;
          margin-bottom: 30px;

          ul {
            display: inline-block;
            line-height: 40px;
            vertical-align: middle;

            li {
              display: inline-block;
              margin-right: 40px;

              span {
                margin-left: 7px;
                vertical-align: middle;
              }
            }
          }

          label {
            font-size: 16px;
            margin-right: 20px;
            text-align: center;
            vertical-align: middle;
          }

          .input_container {
            display: inline-block;
            vertical-align: middle;
            margin-bottom: 0;
            position: relative;

            input[type="text"] {
              height: 40px;
              width: 910px;
            }

            &.hasError {
              input {
                border: 1px solid red;
              }

              .err_msg {
                position: absolute;
                left: 0px;
                bottom: -20px;
                color: red;
                font-size: 12px;
              }
            }
          }

          &.s_time,
          &.s_author,
          &.s_edition,
          &.s_edition_name {
            display: inline-block;
            margin-top: 0;
            margin-right: 30px;

            input[type="text"] {
              height: 40px;
              width: 414px;
            }
          }
        }
      }

      .search_button {
        width: 100%;
        padding-bottom: 30px;
        border-bottom: 7px solid #f0f0f0;

        button {
          width: 100px;
          height: 40px;

          &.btn_search {
            margin-left: 30%;
            background-color: #da261d;
          }

          &.btn_reset {
            margin-left: 30px;
            background-color: #c2c5cd;
          }
        }
      }
    }

    .search_list {
      margin-top: 30px;

      ul {
        li {
          width: 100%;
          cursor: pointer;
          .first_row {
            display: flex;
            .li_title {
              font-size: 16px;
              color: #060606;
              font-weight: 400;
              line-height: 40px;
              flex: 1;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              &:hover {
                color: red;
              }
            }
            .li_time {
              color: #7e7e7e;
              line-height: 40px;
            }
          }
          .sec_row {
            display: flex;
            font-size: 14px;
            font-weight: 400;
            margin-left: 10px;
            color: #7e7e7e;
            flex-wrap: wrap;
            .introduction {
              // display: flex;
              line-height: 40px;
              margin-right: 40px;
              .introduction_title {
                font-weight: 600;
              }
              .introduction_content {
                &:hover {
                  color: red;
                }
              }
            }
            .subtitle {
              // display: flex;
              line-height: 40px;
              .subtitle_title {
                font-weight: 600;
              }
              .subtitle_content {
                &:hover {
                  color: red;
                }
              }
            }
            .mb1 {
              position: relative;
              bottom: 1px;
            }
          }
        }
      }
    }

    .pagination_box {
      margin: 30px auto;
      width: 100%;
      padding: 0 auto;
      text-align: center;
    }
  }

  .footer {
    font-size: 16px;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;

    &.mobile {
      display: none;
    }
  }
}
</style>
